import type { EquipmentCategoryType, SelectedCarType } from "../../utils/types";
import type { ContentViewMode } from "../../utils/constants";

export const SET_SELECTED_CAR = "equipment/setSelectedCar" as const;
export const SET_CONTENT_VIEW_MODE = "equipment/setContentViewMode" as const;
export const SET_OPTIONAL_EQUIPMENT = "equipment/setOptionalEquipment" as const;
export const SET_STANDARD_EQUIPMENT = "equipment/setStandardEquipment" as const;
export const FETCH_EQUIPMENT_FAILED = "equipment/fetchFailed" as const;

type SetSelectedCarType = {
    type: typeof SET_SELECTED_CAR;
    car: SelectedCarType;
};

type SetContentViewModeType = {
    type: typeof SET_CONTENT_VIEW_MODE;
    contentViewMode: ContentViewMode;
};

type SetOptionalEquipmentType = {
    type: typeof SET_OPTIONAL_EQUIPMENT;
    categories: EquipmentCategoryType[];
};

type SetStandardEquipmentType = {
    type: typeof SET_STANDARD_EQUIPMENT;
    categories: EquipmentCategoryType[];
};

type FetchEquipmentFailedType = {
    type: typeof FETCH_EQUIPMENT_FAILED;
};

/**
 * This action should only be used during component initialization, it will not trigger a refetch!
 */
export const setSelectedCar = (car: SelectedCarType): SetSelectedCarType => ({
    type: SET_SELECTED_CAR,
    car,
});

export const setContentViewMode = (contentViewMode: ContentViewMode): SetContentViewModeType => ({
    type: SET_CONTENT_VIEW_MODE,
    contentViewMode,
});

export const setOptionalEquipment = (categories: EquipmentCategoryType[]): SetOptionalEquipmentType => ({
    type: SET_OPTIONAL_EQUIPMENT,
    categories,
});

export const setStandardEquipment = (categories: EquipmentCategoryType[]): SetStandardEquipmentType => ({
    type: SET_STANDARD_EQUIPMENT,
    categories,
});

export const fetchEquipmentFailed = (): FetchEquipmentFailedType => ({
    type: FETCH_EQUIPMENT_FAILED,
});

export type EquipmentActionsType =
    | SetSelectedCarType
    | SetContentViewModeType
    | SetOptionalEquipmentType
    | SetStandardEquipmentType
    | FetchEquipmentFailedType;
